module.exports = __webpack_public_path__ + "static/media/vscode.97b00882.png";